module.exports = __webpack_public_path__ + "img/ltkcurves-4x.dbd74f6.jpg";